/*  
  ApteeekkiPlus custom javascript
  Dependent on files: helpers.js, giosg.js
*/

const customerDataComponent = document.getElementById('customer-data');

let customerOver18 = false;
if (customerDataComponent?.dataset.customerOver18 === 'true') {
  customerOver18 = true;
}
const specialInstructionsTags = customerDataComponent?.dataset.customerSpecialInstructionsTags;

const customer = {
  sha_digest: customerDataComponent?.dataset.digest,
  email: customerDataComponent?.dataset.customerEmail,
  customer_id: customerDataComponent?.dataset.customerId,
  customer_tags: customerDataComponent?.dataset.customerTags.split(','),
  signature_timestamp: customerDataComponent?.dataset.timestamp,
};


window.theme_helpers = window.theme_helpers || {};
window.apteekkiplus = window.apteekkiplus || {};

apteekkiplus.authenticate = async () => {

  const loginParams = await apteekkiplus.api.loginParams();
  // create form
  const form = document.createElement('form');
  form.method = 'POST';
  document.body.appendChild(form);

  form.innerHTML = '';

  // Assuming $form is a reference to a form element
  const inputSAMLRequest = document.createElement('input');
  inputSAMLRequest.type = 'hidden';
  inputSAMLRequest.name = 'SAMLRequest';
  inputSAMLRequest.value = loginParams.SAMLRequest;

  const inputSigAlg = document.createElement('input');
  inputSigAlg.type = 'hidden';
  inputSigAlg.name = 'SigAlg';
  inputSigAlg.value = loginParams.SigAlg;

  // Append the input fields to the form
  form.appendChild(inputSAMLRequest);
  form.appendChild(inputSigAlg);

  // Set the action attribute of the form
  form.setAttribute('action', loginParams.loginUrl);

  fetch('/account/login').then(() => {
    form.submit();
  }).catch((error) => {
    console.error('Error logging in', error);
  });
}

apteekkiplus.logOut = async () => {

  if(!customer.email) return;

  giosgHelper.logOut();
  const logoutParams = await apteekkiplus.api.logoutParams();

  if (!logoutParams) {
    window.location.href = '/account/logout';
    return;
  }
  // create form
  const form = document.createElement('form');
  form.method = 'POST';
  form.action = '';
  document.body.appendChild(form);

  form.innerHTML = '';

  // Assuming $form is a reference to a form element
  const inputSAMLRequest = document.createElement('input');
  inputSAMLRequest.type = 'hidden';
  inputSAMLRequest.name = 'SAMLRequest';
  inputSAMLRequest.value = logoutParams.SAMLRequest;

  const inputSigAlg = document.createElement('input');
  inputSigAlg.type = 'hidden';
  inputSigAlg.name = 'SigAlg';
  inputSigAlg.value = logoutParams.SigAlg;

  // Append the input fields to the form
  form.appendChild(inputSAMLRequest);
  form.appendChild(inputSigAlg);

  // Set the action attribute of the form
  form.setAttribute('action', logoutParams.logoutUrl);

  fetch('/account/logout').then(() => {
    form.submit();
  }).catch((error) => {
    console.error('Error logging out', error);
  });
};


apteekkiplus.checkRedirectRequest = () => {
  const redirectRequest = window.sessionStorage.getItem('redirectRequest');

  if (redirectRequest != null) {
    const redirectRequestObject = JSON.parse(redirectRequest);
    window.sessionStorage.removeItem('redirectRequest');
    window.sessionStorage.removeItem('redirectRequestCount');
    return redirectRequestObject.productUrl;
  };

}


apteekkiplus.checkAccountauthStatus = (authStatus) => {
  const currentPage = window.location.pathname;
  if (authStatus === true && currentPage === '/account') {
    document.querySelector('[data-panel-loading]')?.classList.add('hide');
    document.querySelector('[data-panel-order]')?.classList.remove('hide');
  } else if (authStatus === true && currentPage === '/pages/reseptituotteet') {
    document.querySelector('#authenticate-step .accordion-title')?.classList.add('done-step');
    document.querySelector('#authenticate-step .authenticated')?.classList.remove('hide');
    document.querySelector('#order-step .button')?.classList.remove('hide');
    document.querySelector('[data-detail-loading]')?.classList.add('hide');
    document.querySelector('[data-detail-authenticated]')?.classList.remove('hide');
    document.querySelector('[data-summary-authenticate]')?.click();
    document.querySelector('[data-summary-order]')?.click();
    document.querySelector('[data-authentication-checkbox')?.classList.add('done');
    document.querySelector('[data-order-button')?.classList.remove('hide');
  } else if (currentPage === '/account') {
    document.querySelector('[data-panel-loading]')?.classList.add('hide');
    document.querySelector('[data-panel-authenticate]')?.classList.remove('hide');
  } else if (currentPage === '/pages/reseptituotteet') {
    document.querySelector('#authenticate-step .button')?.classList.remove('hide');
    document.querySelector('#authenticate-step .unauthenticated')?.classList.remove('hide');
    document.querySelector('[data-detail-loading]')?.classList.add('hide');
    document.querySelector('[data-detail-authenticate]')?.classList.remove('hide');
  } else {
    document.querySelector('[data-panel-loading]')?.classList.add('hide');
    document.querySelector('[data-panel-authenticate]')?.classList.remove('hide');
  }
};

apteekkiplus.api = {
  loginParams: async () => {
    try {
      const response = await fetch('/apps/apteekkiplus/api/v1/saml/login_params', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(customer),
      })
      if (response.status !== 200) {
        throw new Error('Error getting login params');
      }
      else {
        return await response.json();
      }
    } catch (error) {
      console.error('Error getting login params', error);
    }
  },
  logoutParams: async () => {
    try {
      const response = await fetch('/apps/apteekkiplus/api/v1/saml/logout_params', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(customer),
      });

      if(response.status !== 200) {
        throw new Error('Error getting logout params');
      }
      else {
        return await response.json();
      }

    } catch (error) {
      console.error('Error getting logout params', error);
      return null;
    }
  },
  getStatus: async () => {
    const params = new URLSearchParams(customer);
    const url = new URL('/apps/apteekkiplus/api/v1/customers', window.location.origin);
    for (const [key, value] of Object.entries(customer)) {
      // If the value is an array (like customer_tags), join it into a comma-separated string
      url.searchParams.append(key, Array.isArray(value) ? value.join(',') : value);
    }
    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if(response.status === 200) {
        return true;
      } else {
        return false;
      }
    } catch (error) {
      console.error('Error getting status', error);
      return false;
    }
  },
  createDraftOrder: async () => {
    handleCartResponse = async (cart) => {
      const chat = window.GiosgClient.activeChat;
      if (chat?.id) {
        if (customer.email) {
          const productName = window.theme_helpers.product_name;
          giosgHelper.createAndSubmitCounselingTag(productName);
        }
        return await apteekkiplus.api.createOrder(cart, chat);
      }
      else {
        setTimeout(function () {
          handleCartResponse(cart);
        }, 1000);
      }
    };


    const cart = await helpers.api.getCart();
    if (cart) {
      await handleCartResponse(cart);
    }
  },
  createOrder: async (cart, chat) => {
    const response = await fetch('/apps/apteekkiplus/api/v1/draft_orders', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ ...customer, ...{ cart: cart, chat_id: chat.id }}),
    });
    return await response.json();
  }
}

if (!customElements.get('logout-button')) {
  customElements.define('logout-button', class LogoutButton extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('click', async () => {
        apteekkiplus.logOut();
      });
    };
  });
};

if (!customElements.get('authentication-button')) {
  customElements.define('authentication-button', class AuthenticationButton extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('click', async () => {
        if (this.id === 'product-auth') {
          const productTitle = this.dataset.productTitle;
          const productUrl = this.dataset.productUrl;
          window.sessionStorage.setItem('redirectRequest', 
            JSON.stringify({
              productTitle: productTitle,
              productUrl: productUrl,
            })
          );
          window.sessionStorage.setItem('redirectRequestCount', 6);
        };
        apteekkiplus.authenticate();
      });
    };
  });
};

// Opens chat window
if (!customElements.get('chat-button')) {
  customElements.define('chat-button', class ChatButton extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('click', async (event) => {
        event.stopPropagation();
        if(customer.email) {
          if (this.dataset.productTitle) {
            window.theme_helpers.product_name = this.dataset.productTitle;
          }
        }
        giosgHelper.openChatWindow();
      });
    };
  });
}

// Adds redirect after login
if (!customElements.get('login-button')) {
  customElements.define('login-button', class LoginButton extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('click', () => {
        const productTitle = this.dataset.productTitle;
        const productUrl = this.dataset.productUrl;

        window.sessionStorage.setItem('redirectRequest', 
          JSON.stringify({
            productTitle: productTitle,
            productUrl: productUrl,
          })
        );
        window.sessionStorage.setItem('redirectRequestCount', 1);
        window.location = "/account/login";
      });
    };
  });
}


if (customer.email) {
  const redirect = apteekkiplus.checkRedirectRequest();
  if (redirect) {
    window.location = redirect;
  }
  else {
    document.addEventListener("DOMContentLoaded", async () => {
      const loggedIn = await apteekkiplus.api.getStatus();
      apteekkiplus.checkAccountauthStatus(loggedIn);
    });
  }
} else {
  const redirectRequestCount = window.sessionStorage.getItem("redirectRequestCount");
  if (redirectRequestCount != null) {
    let redirectRequestNumber = parseInt(redirectRequestCount);
    if (redirectRequestNumber <= 8) {
      redirectRequestNumber += 1;
      window.sessionStorage.setItem("redirectRequestCount", redirectRequestNumber);
    } else {
      window.sessionStorage.removeItem("redirectRequestCount");
      window.sessionStorage.removeItem("redirectRequest");
    }
  }
}


